const apiUrl = process.env.REACT_APP_API_URL;

export const GetEmailsActivitats = async (page: string, any: string, idcent?: string): Promise<any[]> => {
    try {
        const idcentParam = idcent && idcent !== 'TOTES' ? `&idcent=${encodeURIComponent(idcent)}` : '';
        const response = await fetch(`${apiUrl}:8073/emails/activitats?any=${any}${idcentParam}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': 'loop'
            }
        });
        if (!response.ok) {
            console.error('GetEmailsActivitats error:', response.status);
            return [];
        }
        const jsonData = await response.json();
        return Array.isArray(jsonData) ? jsonData : [];
    } catch (error) {
        console.log('GetEmailsActivitats fetch error:', error);
        return [];
    }
};
